import reducer from './reducer'

import * as ratesOperations from './operations'
import * as ratesSelectors from './selectors'

export { ratesOperations, ratesSelectors }

export default reducer
